import type React from 'react';

import { Alert, Button, Modal, ModalBody, ModalFooter, ModalHeader, Text } from '@change/ds-core-ui';

import { Translate, useI18n } from '@change-corgi/core-react/i18n';

import { EmailDecisionMakerModalBody } from './hooks/useEmailDecisionMakerModalBase/components/EmailDecisionMakerModalBody';
import { useEmailDecisionMakerNotification } from './hooks/useEmailDecisionMakerNotification';

type Props = {
	onDismiss?: () => void;
};

export const EmailDecisionMaker: React.FC<Props> = ({ onDismiss }) => {
	const {
		data: { isModalOpen },
		actions,
	} = useEmailDecisionMakerNotification({ onDismiss });
	const { translate } = useI18n();

	return (
		<>
			<Alert
				className="h-full w-full [&>div>div]:flex-row"
				variant="info"
				heading={translate('corgi.petition.starter_dashboard.notifications.email_decision_maker.heading')}
				{...(onDismiss && {
					onDismissClick: actions.handleDismiss,
					dismissButtonAriaLabel: translate(
						'corgi.petition.starter_dashboard.notifications.email_decision_maker.dismiss_button_aria_label',
					),
				})}
				data-qa="starter-can-email-dm-section-message"
			>
				<Text as="p">
					<Translate value="corgi.petition.starter_dashboard.notifications.email_decision_maker.body" />
				</Text>
				<Button className="mt-4" size="x-small" variant="secondary-solid" onClick={actions.handleClick}>
					<Translate value="corgi.petition.starter_dashboard.notifications.email_decision_maker.primary_action_button" />
				</Button>
			</Alert>
			<Modal
				isOpen={isModalOpen}
				onClose={actions.closeModal}
				closeButtonAriaLabel={translate('corgi.components.modal.close_button')}
				size="small"
			>
				<ModalHeader
					title={translate('corgi.petition.starter_dashboard.notifications.email_decision_maker.modal_title')}
				/>
				<ModalBody>
					<EmailDecisionMakerModalBody />
				</ModalBody>
				<ModalFooter>
					<Button data-qa="close-modal-button" size="small" variant="primary" onClick={actions.closeModal}>
						<Translate value="corgi.petition.starter_dashboard.notifications.email_decision_maker.modal_close_button" />
					</Button>
				</ModalFooter>
			</Modal>
		</>
	);
};
